import React, { Component } from 'react'
import { Modal, FormGroup, ControlLabel, Row, Col} from 'react-bootstrap'
import Validation from 'react-validation'
import Repository from '../../felles/repository'
import moment from 'moment'
import _ from 'lodash'
import { resolve } from '../../dependencies'
import '../../felles/valideringsRegler'
moment.locale('nb')

export default class FlyttModal extends Component {

    constructor(props) {
        super(props)
        this.state = {
            arbeidslister: [],
            selectedArbeidslisteId : 0,
            laster: true
        }

        this._submit = this._submit.bind(this)
        this._handleSelectedArbeidsliste = this._handleSelectedArbeidsliste.bind(this)
        this._hentArbeidslister = this._hentArbeidslister.bind(this)
        this._getArbeidslisterByStatus = this._getArbeidslisterByStatus.bind(this)
    }

    componentDidMount() {
        resolve(Repository).hentArbeidslister('').then(liste => this.setState({
            arbeidslister: liste,
            laster: false
        }))
    }

    _hentArbeidslister() {
        resolve(Repository).hentArbeidslister('').then(liste => this.setState({
            arbeidslister: liste
        }))        
    }

    _submit = (event) => {
        event.preventDefault()              
        this.props.onFlytt(this.state.selectedArbeidslisteId)
    }

    _handleSelectedArbeidsliste(data) {
        console.log(data.target.value)
        this.setState({
            selectedArbeidslisteId: data.target.value
        });
    }

    _getArbeidslisterByStatus(statusId){
        return _.map(_.sortBy(_.filter(this.state.arbeidslister, a => a.Status === statusId), 'Tittel'), function(arbeidsliste){
            return <option key={arbeidsliste.Id} value={arbeidsliste.Id}>
            {arbeidsliste.Tittel}              
            </option>
        })
    }

    render() {
        return (
            <Modal show={this.props.isOpen} onHide={this.props.onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Flytt</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                     <Validation.components.Form ref={c => this.form = c} onSubmit={this._submit}>
                        <Row>
                            <Col sm={12} >
                                <FormGroup>
                                    <ControlLabel>Flytt {this.props.adresse} til arbeidsliste</ControlLabel>                                                                   
                                      <Validation.components.Select
                                        errorClassName='is-invalid-input'                                        
                                        validations={['required']}
                                        value={this.state.selectedArbeidslisteId}                                        
                                        onChange={this._handleSelectedArbeidsliste}
                                        className="form-control"
                                    >
                                    <option disabled> -- Velg arbeidsliste -- </option>
                                    <optgroup label="Ikke aktiverte">
                                    {
                                        this._getArbeidslisterByStatus(0)

                                    }
                                    </optgroup>
                                    <optgroup label="Aktiverte">
                                    {
                                        this._getArbeidslisterByStatus(1)
                                    }
                                    </optgroup>
                      
                                    </Validation.components.Select>
                                </FormGroup>
                            </Col>
                        </Row>
                         
                         <Validation.components.Button className="btn btn-primary">OK</Validation.components.Button>

                    </Validation.components.Form>
                </Modal.Body>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/planlegging/arbeidsliste/flyttVannmaalerModal.jsx